export interface Pedido {
  id: number;
  identificador?: string;
  id_centro_logistico: number;
  id_proveedor: number;
  numero?: string;
  fecha: Date;
  tipo_documento?: any;
  ind_iberado: number;
  numero_proveedor?: string;
  comprador?: string;
  condicion_uso_cfdi?: string;
  condicion_forma_pago?: string;
  condicion_metodo_pago?: string;
  estatus_descripcion?: string;
  estatus: number;
  tipo_cambio: number;
  moneda?: string;
  monto_total: number;
  terminos_pago?: string;
  terminos_entrega?: string;
  indicador_anticipo?: string;
  fecha_vencimiento_anticipo?: string;
  importe_anticipo: number;
  correo_anticipo?: string;
  suma_anticipo: number;
  ruta_pdf?: string;
  fecha_creacion: Date;
  fecha_actualizacion: Date;
  usuario_creacion?: string;
  usuario_actualizacion?: string;
  centro_logistico_codigo?: string;
  proveedor_nombre?: string;
  empresa?: string;
  empresa_codigo?: string;
  empresa_rfc?: string;
  sucursal?: string;
}

export interface EntradaMercancia {
  id: number;
  identificador?: string;
  id_orden_compra: number;
  codigo_recepcion?: string;
  fecha_documento?: string;
  fecha_contable?: string;
  nota_entrega?: string;
  activo: boolean;
  facturado: boolean;
  movimiento?: string;
  monto: number;
  ruta_pdf?: string;
  fecha_creacion?: string;
  fecha_actualizacion?: string;
  usuario_creacion?: string;
  usuario_actualizacion?: string;
  num_orden_compra?: string;
  proveedor?: string;
  rfc_proveedor?: string;
  empresa?: string;
  empresa_codigo?: string;
  sucursal?: string;
  sucursal_codigo?: string;
  checked: boolean;
}

export class ComprobantesPedido {
  numero:  string;
  monto:  number;
  monto_anticipo:  number;
  identificador:  string;
  id:  number;
  uuid:  string;
  serie:  string;
  folio:  string;
  tipo_comprobante:  string;
  tipo_documento:  string;
  metodo_pago:  string;
  forma_pago:  string;
  moneda:  string;
  subtotal:  number;
  descuento:  number;
  total:  number;
  doc_ruta_pdf:  string;
  doc_ruta_xml:  string;
  doc_folio_sap:  string;
  fecha_carga:  string;

  constructor() {
      this.numero = '';
      this.monto = 0.00;
      this.monto_anticipo = 0.00;
      this.identificador = '';
      this.id = 0;
      this.uuid = '';
      this.serie = '';
      this.folio = '';
      this.tipo_comprobante = '';
      this.tipo_documento = '';
      this.metodo_pago = '';
      this.forma_pago = '';
      this.moneda = '';
      this.subtotal = 0.00;
      this.descuento = 0.00;
      this.total = 0.00;
      this.doc_ruta_pdf = '';
      this.doc_ruta_xml = '';
      this.doc_folio_sap = '';
      this.fecha_carga = '';
  }

}
